import { Link } from 'react-router-dom';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const FactsMobile = styled(Link, {})({
  display: 'flex',
  paddingBottom: 50,
  minHeight: 120,

  flexDirection: 'column',
  justifyContent: 'space-between',

  color: theme.palette.black,
  textDecoration: 'none',

  [theme.breakpoints.up('laptop')]: {
    display: 'none',
  },
});
